const defaultPermissionsForm = {
    id: '',
    name: '',
    content_type_id: '',
    codename: '',
}

export default defaultPermissionsForm;